module.exports = __webpack_public_path__ + "static/img/home-3.7a439f49.png";